export enum ListPeriodFilterShortcut {
    NONE,
    CURRENT_MONTH,
    LAST_MONTH,
    LAST_THIRTY_DAYS,
    LAST_NINETY_DAYS,
    CURRENT_YEAR,
    CUSTOM
}